<div class="modal">
  <div class="modal-ctn">

    <div class="options">
      <div>{{ 'TEAM.UPDATE' | translate | uppercase }}</div>
      <img src="assets/images/close.svg" (click)="close()"/>
    </div>

    @if (show) {
      <form [formGroup]="form">
        <div>
          <label>{{ 'TEAM.MEMBER' | translate }} ID</label>
          <a>{{ team.teamMemberId }}</a>
        </div>
        <div>
          <label>{{ 'TEAM.FIRST_NAME' | translate }}</label>
          <input type="text" formControlName="teamMemberFirstName">
        </div>
        <div>
          <label>{{ 'TEAM.LAST_NAME' | translate }}</label>
          <input type="text" formControlName="teamMemberName">
        </div>
        <div>
          <label>{{ 'TEAM.LANGUAGE' | translate }}</label>
          <input type="text" formControlName="teamMemberLanguage">
        </div>
        <div>
          <label>{{ 'TEAM.PHONE' | translate }}</label>
          <input type="text" formControlName="teamMemberCellularPhone">
        </div>
        <div>
          <label>{{ 'TEAM.EMAIL' | translate }}</label>
          <input type="text" formControlName="teamMemberEmail">
        </div>
        <div>
          <label>{{ 'TEAM.LOCATION' | translate }}</label>
          <select formControlName="peoplelocationcode">
            @for (peopleLocation of peopleLocations; track peopleLocation) {
              <option value="{{ peopleLocation.peoplelocationcode }}">{{ peopleLocation.peoplelocationname }}</option>
            }
          </select>
        </div>
        <div>
          <label>{{ 'TEAM.MOBILE_DEVICE' | translate }}</label>
          <select formControlName="mobileDevicepk">
            <option value="null"></option>
            @for (mobileDevice of mobileDevices; track mobileDevice) {
              <option value="{{ mobileDevice.mobileDevicepk }}">{{ mobileDevice.mobileDeviceModelSupplier }} / {{ mobileDevice.mobileDeviceName }}</option>
            }
          </select>
        </div>
        @for (role of roles; track role) {
          <div>
            <label>{{ role }}</label>
            <input type="checkbox" [checked]="hasRole(role)" (change)="updateRole($event, role)"/>
          </div>
        }
      </form>
    }

    <div class="footer">
      <button (click)="update()" [disabled]="form.invalid">{{ 'UPDATE' | translate | uppercase }}</button>
    </div>

  </div>
</div>